import { SURFACE_CONFIG } from "../lib/surface-config.js";
// FIX: Correct import path for PROPERTY_TYPE_MAP
import { PROPERTY_TYPE_MAP, normalizePropertyType } from './utils/propertyTypes';
// ✅ Partnerselectie, opslag in sessionStorage en navigatie
window.selectPartner = function (partnerId) {
  if (!partnerId) {
    console.warn("Geen partnerId ontvangen");
    return;
  }

  if (!Array.isArray(window.companies)) {
    console.warn("⚠️ window.companies is niet beschikbaar");
    return;
  }

  const companyName = decodeURIComponent(partnerId).replace(/-/g, " ");

  const selectedAdvisor = window.companies.find(advisor =>
    advisor.company &&
    advisor.company.toLowerCase() === companyName.toLowerCase()
  );

  if (!selectedAdvisor) {
    console.warn("⚠️ Geen advisor gevonden voor:", companyName);
    return;
  }

  // 🔑 ENIGE waarheid: advisor + partnerId samen
  const selectedAdvisorData = {
    ...selectedAdvisor,
    partnerId,
    selectedAt: Date.now()
  };

  sessionStorage.setItem(
    "selectedAdvisorData",
    JSON.stringify(selectedAdvisorData)
  );

  console.log("✅ selectedAdvisorData opgeslagen (sessionStorage):", selectedAdvisorData);



  /* --------------------------------------------------
   * Navigatie
   * -------------------------------------------------- */
  if (window.router?.navigate) {
    window.router.navigate("/book-epc/");
  } else {
    window.location.href = "/book-epc/";
  }
};


    // 📍 locatie
    function normalizeProvince(raw) {
  if (!raw) return null;

  const p = normalizeText(raw)
    .replace(/[\/]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (p.includes("alava") || p.includes("araba")) return "alava";
  if (p.includes("gipuzkoa") || p.includes("guipuzcoa")) return "gipuzkoa";
  if (p.includes("bizkaia")) return "bizkaia";

  return p;
}

window.sortAdvisors = function (type) {
  if (!Array.isArray(window.companies)) return;

  const sorted = [...window.companies].sort((a, b) => {
    const priceA = a?.matched_price?.price ?? Infinity;
    const priceB = b?.matched_price?.price ?? Infinity;

    const deliveryA = a?.matched_price?.delivery_days ?? Infinity;
    const deliveryB = b?.matched_price?.delivery_days ?? Infinity;

    return type === "price"
      ? priceA - priceB
      : deliveryA - deliveryB;
  });

  // ✅ enige waarheid
  window.companies = sorted;

  const results = document.getElementById("results");
  renderAdvisors(results);
};




// Extract surface number
function extractSurfaceNumber(superficie) {
  if (typeof superficie === "number") return superficie;
  if (typeof superficie !== "string") return null;
  const nums = superficie.match(/\d+/g);
  if (!nums) return null;
  if (nums.length >= 2) {
    return Math.round((+nums[0] + +nums[1]) / 2);
  }
  return Number(nums[0]);
}

// Normalize accents + lowercase
function normalizeText(str) {
  return str
    ?.normalize("NFD")
    ?.replace(/[\u0300-\u036f]/g, "")
    ?.toLowerCase();
}




// Property type mapping met normalization en mapping table
function mapPropertyType(raw) {
  if (!raw) return null;
  const normalized = normalizePropertyType(raw);
  return PROPERTY_TYPE_MAP[normalized] || normalized;
}

function getSurfaceRange(propertyType, surfaceValue) {
  const config = SURFACE_CONFIG[propertyType];
  if (!config) return null;

  const value = extractSurfaceNumber(surfaceValue);
  if (!Number.isFinite(value)) return null;

  const range = config.ranges.find(r =>
    (r.min === null || value >= r.min) &&
    (r.max === null || value <= r.max)
  );

  return range ? range.label : null;
}

function collectCodigoRegistrales(bi) {
  const codes = new Set();

  // 1. dt.cri (als aanwezig)
  if (bi?.dt?.cri) {
    codes.add(bi.dt.cri);
  }

  // 2. rc → samengestelde código
  const rc = bi?.idbi?.rc;
  if (rc) {
    const { pc1, pc2, car, cc1, cc2 } = rc;
    if ([pc1, pc2, car, cc1, cc2].every(Boolean)) {
      codes.add(`${pc1}${pc2}${car}${cc1}${cc2}`);
    }
  }

  return Array.from(codes);
}
/* =======================
   Page HTML
======================= */

export function ComparePage() {
  return `
    <section class="section bg-gray-50">
      <div class="container max-w-6xl mx-auto flex gap-8">
        <div class="w-1/3">
          <div id="property-results-content"
               class="bg-white rounded-lg shadow p-6">
            <p class="text-sm text-gray-500">Loading data…</p>
            <div class="max-w-md rounded-lg border border-gray-200 bg-gray-50 p-6 mt-6">
              <p class="font-semibold text-gray-900 mb-3">
                What you are requesting:
              </p>
              <p class="text-gray-800 mb-4">
                Energy certification
              </p>
              <div class="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>
                  <span class="font-semibold">1st - Visit to the property</span> to carry out the inspection. Duration approx. 30 minutes.
                </p>
                <p>
                  <span class="font-semibold">2nd - Preparation of the energy certificate.</span>
                  Timeframe approx. 1 or 2 days.
                </p>
                <p>
                  <span class="font-semibold">3rd - Registration</span> and payment of fees if applicable at the relevant official body.
                </p>
                <p>
                  <span class="font-semibold">4th - Issuance of the energy label</span> by the administration.
                </p>
                <p>
                  <span class="font-semibold">5th - Sending</span> of the documentation by email.
                </p>
              </div>
            </div>
            
          </div>
        </div>

        <div class="w-2/3">
          <h3 class="text-lg font-semibold mb-4">Available advisors</h3>
<!-- Filters -->
<div class="bg-white border border-gray-200 rounded-lg p-4 mb-6">
  <div class="flex flex-wrap gap-3 items-center">
    <span class="text-sm font-semibold text-gray-700">Sort by:</span>

    <button
      onclick="sortAdvisors('price')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      💶 Lowest price
    </button>

    <button
      onclick="sortAdvisors('delivery')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      ⚡ Fastest delivery
    </button>
  </div>
</div>
 
          <div id="results"></div>
        </div>
      </div>
    </section>
  `;
}

/* =======================
   Init
======================= */

export function initializeComparePage() {
  const controller = createCompareController();
  controller.init();
}

function createCompareController() {
  const state = {
    propertyData: null,
    companies: [],
  };

  async function init() {
    await loadAndEnrichPropertyResults();
    await loadAndFilterCompanies();
  }

  /* =======================
     Property
  ======================= */

async function loadAndEnrichPropertyResults() {
  const container = document.getElementById("property-results-content");
  if (!container) return;

  const raw = sessionStorage.getItem("propertySearchData");
  if (!raw) {
    container.innerHTML = `<p class="text-sm">No property data.</p>`;
    return;
  }

  state.propertyData = JSON.parse(raw);
  container.innerHTML = loadingHtml("Getting property data…");

  try {
    const { default: CatastroClient } = await import("./catastro-browser.js");
    const client = new CatastroClient();

    let result;

    if (
      state.propertyData.searchType === "registratiecode" &&
      state.propertyData.codigoRegistral
    ) {
      result = await client.getCodigoRegistralData(
        state.propertyData.codigoRegistral
      );
    } else {
      result = await client.getPropertyData(
        state.propertyData.codigoProvincia,
        state.propertyData.codigoMunicipio,
        state.propertyData.codigoVia,
        state.propertyData.numero
      );
    }

    


    state.propertyData = enrichWithCatastroResult(
      state.propertyData,
      result
    );
    
// ❌ Geen geldig adres → stop hier
  const invalidPostalCodes = ['', '0', '00000', null, undefined];

if (
  !state.propertyData ||
  invalidPostalCodes.includes(state.propertyData.codigoPostal)
) {
  container.innerHTML = `
    <div class="bg-red-50 border border-red-200 rounded-lg p-6">
      <h2 class="text-xl font-bold text-red-700 mb-3">
        ❌ Invalid address
      </h2>
      <p class="text-gray-700 mb-4">
        The entered address does not exist or could not be found in the Cadastre.
      </p>
      <p class="text-sm text-gray-600 mb-4">
        Redirecting to the search form…
      </p>
    </div>
  `;

  // ⏱️ short UX delay
  setTimeout(() => {
    if (window.router?.navigate) {
      window.router.navigate('/cadastro/');
    } else {
      window.location.href = '/cadastro/';
    }
  }, 2000);

  throw new Error("Invalid property data");
}




    try {
  const bookingPropertyData = {
    // 🔹 genormaliseerde property data
    provincia: state.propertyData.provincia,
    municipio: state.propertyData.municipio,
    codigoPostal: state.propertyData.codigoPostal,
    anoConstruccion: state.propertyData.anoConstruccion,
    superficie: state.propertyData.superficie,
    codigoRegistrales: state.propertyData.codigoRegistrales,

    // 🔹 context
    buildingType:
      state.propertyData.buildingType ||
      state.propertyData.tipo ||
      'No especificado',

    serviceType:
      state.propertyData.serviceType ||
      state.propertyData.servicio ||
      'No especificado',

    // 🔹 metadata
    source: 'compare-page',
    timestamp: Date.now()
  };

  // 🔑 ENIGE waarheid voor de booking-flow
  sessionStorage.setItem(
    'bookingPropertyData',
    JSON.stringify(bookingPropertyData)
  );

  console.log('✅ bookingPropertyData opgeslagen (sessionStorage)', bookingPropertyData);
} catch (e) {
  console.warn('❌ Opslaan bookingPropertyData mislukt', e);
}


    renderPropertySummary(container);

  } catch (e) {
    console.error(e);
    container.innerHTML = `<p class="text-sm text-red-600">Catastro fout</p>`;
  }
}


  function renderPropertySummary(container) {
    const buildingType =
      state.propertyData.buildingType ||
      state.propertyData.tipo ||
      "Not specified";

    const serviceType =
      state.propertyData.serviceType ||
      state.propertyData.servicio ||
      "Not specified";

    container.innerHTML = `
      <div class="border-b pb-3 mb-3 text-sm">
        <div><strong>Building type:</strong> ${buildingType}</div>
        <div><strong>Service type:</strong> ${serviceType}</div>
      </div>

      <div class="text-sm space-y-1 mb-6">
        <div><strong>Province:</strong> ${state.propertyData.provincia}</div>
        <div><strong>Municipality:</strong> ${state.propertyData.municipio}</div>
        <div><strong>Postal code:</strong> ${state.propertyData.codigoPostal}</div>

        ${state.propertyData.anoConstruccion
          ? `<div><strong>Year of construction:</strong> ${state.propertyData.anoConstruccion}</div>`
          : ""}

        <div><strong>Surface:</strong> ${state.propertyData.superficie} m²</div>

        ${Array.isArray(state.propertyData.codigoRegistrales) &&
        state.propertyData.codigoRegistrales.length
          ? `
            <div>
              <strong>Registry code:</strong>
              <ul class="ml-4 list-disc">
                ${state.propertyData.codigoRegistrales
                  .map(c => `<li>${c}</li>`)
                  .join("")}
              </ul>
            </div>
            `
          : ""}
      </div>

      <div class="max-w-md rounded-lg border border-gray-200 bg-gray-50 p-6 mt-2">
        <p class="font-semibold text-gray-900 mb-3">
          What you are requesting:
        </p>
        <p class="text-gray-800 mb-4">
          Energy certification
        </p>
        <div class="space-y-3 text-sm text-gray-700 leading-relaxed">
          <p>
            <span class="font-semibold">1st - Visit to the property</span> to carry out the inspection. Duration approx. 30 minutes.
          </p>
          <p>
            <span class="font-semibold">2nd - Preparation of the energy certificate.</span>
            Timeframe approx. 1 or 2 days.
          </p>
          <p>
            <span class="font-semibold">3rd - Registration</span> and payment of fees if applicable at the relevant official body.
          </p>
          <p>
            <span class="font-semibold">4th - Issuance of the energy label</span> by the administration.
          </p>
          <p>
            <span class="font-semibold">5th - Sending</span> of the documentation by email.
          </p>
        </div>
      </div>

      <div class="max-w-md rounded-xl border border-gray-200 bg-white p-6 mt-4">
        <h2 class="text-base font-semibold text-gray-900 mb-2">
          More information about:
        </h2>
        <p class="text-gray-800 mb-3">
          Energy certification
        </p>
        <p class="text-sm text-gray-700 leading-relaxed mb-4">
          The energy certificate
          <span class="font-semibold">
            is essential for selling or renting a property
          </span>
          and provides information about the energy consumption and CO2 emissions of a property.
          <span class="font-semibold">
            They are valid for 10 years.
          </span>
        </p>
        <a
          href="/faq-customer/"
          class="text-sm font-semibold text-green-600 hover:text-green-700 transition"
        >
          Read more
        </a>
      </div>
    `;
  }

/* =======================
   Companies
======================= */

async function loadAndFilterCompanies() {
  const results = document.getElementById("results");
  if (!results || !state.propertyData) return;

  results.innerHTML = loadingHtml("Searching for advisors…");

  try {
    const params = new URLSearchParams();


      params.append("province", normalizeProvince(state.propertyData.provincia));
    params.append(
      "city",
      normalizeText(state.propertyData.municipio)
    );

    // 🏠 property type + surface
    const propertyType = mapPropertyType(
      state.propertyData.buildingType || state.propertyData.tipo
    );

    if (propertyType) {
      params.append("property_type", propertyType);

      const surface = extractSurfaceNumber(state.propertyData.superficie);
      if (Number.isFinite(surface)) {
        params.append("surface", surface);
      }
    }

    // ✅ SAME-ORIGIN request (via proxy / backend)
    const res = await fetch(`/api/companies?${params.toString()}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error(`API error ${res.status}`);
    }

    const data = await res.json();

    state.companies = Array.isArray(data)
      ? data.filter(c => typeof c?.company === "string")
      : [];

    // expose globally (zoals je al deed)
    window.companies = state.companies;

    renderAdvisors(results);

  } catch (err) {
    console.error("Failed to load companies:", err);
    results.innerHTML = `<p>❌ No advisors found</p>`;
  }
}

  /* =======================
     Render advisors
  ======================= */

  function renderAdvisors(container) {
    if (!state.companies.length) {
      container.innerHTML = `<p class="text-gray-500">No results</p>`;
      return;
    }

    container.innerHTML = state.companies.map(renderAdvisorCard).join("");
  }

  function renderAdvisorCard(advisor) {
    // Location text logic: only show provinces


    // Rating and stars logic
    const rating = advisor?.rating || 4.7;
    const stars = Math.round(rating);
    const emptyStars = 5 - stars;
    const starSvg = '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const emptyStarSvg = '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const allStars = Array(stars).fill(starSvg).concat(Array(emptyStars).fill(emptyStarSvg)).join("");

// Partner ID and logo
const partnerId = encodeURIComponent(
  advisor?.company?.toLowerCase()?.replace(/\s+/g, "-") || "unknown-advisor"
);

const LOGO_BASE_URL = "https://ceecasasespana.com";

const logoUrl = (() => {
  const logo = advisor?.logo?.trim();

  if (!logo) {
    return `${LOGO_BASE_URL}/logos/LogoES.webp`;
  }

  // Absolute URL → laten staan
  if (logo.startsWith("http")) {
    return logo;
  }

  // Relatief pad → ceecasasespana.com
  return `${LOGO_BASE_URL}${logo}`;
})();


    // Price and delivery
    let currentPrice = null;
    let deliveryDays = null;
    if (advisor?.matched_price?.price) {
      currentPrice = Number(advisor.matched_price.price);
      deliveryDays = advisor.matched_price.delivery_days;
    }

    // Determine card background color based on role
    const isAdmin = advisor?.role === 'admin';
    const cardBgClass = isAdmin ? 'bg-gray-200' : 'bg-white';

    return `
        <div class="partner-card ${cardBgClass} rounded-lg border border-gray-200 p-4 hover:shadow-lg transition-shadow duration-300 mb-4" data-partner-id="${partnerId}">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4 flex-1">
              <img src="${logoUrl}" alt="${advisor?.company || 'Asesor'} logo" class="w-16 h-16 object-contain" />
              <div class="flex-1">
                <div class="flex items-center gap-6 mb-2">
                  <h3 class="text-lg font-bold text-gray-900">Company</h3>
                  <span class="text-sm text-gray-700">Rating:</span>
                  <span class="flex items-center gap-1">
                    ${allStars}
                    <span class="text-lg font-semibold text-gray-900">${rating}</span>
                  </span>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">${advisor?.company || 'Unknown company'}</h3>
               
                <div class="flex gap-4 mt-3">
                  <button class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" 
                      onclick="toggleAdvisorInfo('${partnerId}', 'about')" 
                      id="tab-about-${partnerId}">
                    About the advisor ↓
                  </button>
                  <button class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" 
                      onclick="toggleAdvisorInfo('${partnerId}', 'reviews')" 
                      id="tab-reviews-${partnerId}">
                    Customer reviews ↓
                  </button>
                </div>
              </div>
            </div>
            <div class="flex flex-col items-end gap-3 ml-4">
              <div class="text-right">
                ${currentPrice !== null ? `
                  <div class="flex items-baseline gap-2">
                    <span class="text-gray-900 font-semibold">
                      €${currentPrice.toFixed(2).replace('.', ',')}<span class="text-sm text-gray-700"> + VAT (21%)<br>
                      <span class="text-sm text-gray-700">Total: €${(currentPrice * 1.21).toFixed(2).replace('.', ',')}</span>
                    </span>
                  </div>
                  <span class="text-xs text-gray-500">
                    Delivery in ${deliveryDays} working day(s)
                  </span>
                ` : `
                  <span class="text-gray-500 text-sm italic">
                    Price on request
                  </span>
                `}
              </div>
          <button class="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-semibold text-sm transition-colors"
            onclick="selectPartner('${partnerId}')">
            Request
          </button>
            </div>
          </div>
          <div id="advisor-content-${partnerId}" class="hidden mt-4 pt-4 border-t border-gray-200">
            <div id="about-content-${partnerId}" class="hidden"></div>
            <div id="reviews-content-${partnerId}" class="hidden"></div>
          </div>
        </div>
      `;
  }
// Toggle voor "Over adviseur" / "Klantervaringen" identiek aan ComparePage.js
window.toggleAdvisorInfo = function (partnerId, tabType) {
  const contentDiv = document.getElementById(`advisor-content-${partnerId}`);
  const aboutContent = document.getElementById(`about-content-${partnerId}`);
  const reviewsContent = document.getElementById(`reviews-content-${partnerId}`);
  const aboutTab = document.getElementById(`tab-about-${partnerId}`);
  const reviewsTab = document.getElementById(`tab-reviews-${partnerId}`);

  const wasAboutVisible = !aboutContent.classList.contains("hidden");
  const wasReviewsVisible = !reviewsContent.classList.contains("hidden");

  // Reset alles
  aboutContent.classList.add("hidden");
  reviewsContent.classList.add("hidden");
  aboutTab.classList.remove("bg-gray-100", "font-medium");
  reviewsTab.classList.remove("bg-gray-100", "font-medium");

  if (
    (tabType === "about" && wasAboutVisible) ||
    (tabType === "reviews" && wasReviewsVisible)
  ) {
    contentDiv.classList.add("hidden");
    return;
  }

  contentDiv.classList.remove("hidden");

  if (tabType === "about") {
    // Buscar los datos del asesor
    const advisor = window.companies.find(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    aboutContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-2">About ${advisor?.company || partnerId}</h4>
      <p class="text-sm text-gray-600">${advisor?.description ? advisor.description : "No description available."}</p>
    `;
    aboutContent.classList.remove("hidden");
    aboutTab.classList.add("bg-gray-100", "font-medium");
  } else {
    // Buscar el índice del asesor para la valoración
    const index = window.companies.findIndex(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    const rating = window.companies[index]?.rating || 3.6;
    const reviews = window.companies[index]?.reviews || 29;
    const stars = Math.round(rating);

    const starSvg =
      '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const emptyStarSvg =
      '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const allStars = Array(stars)
      .fill(starSvg)
      .concat(Array(5 - stars).fill(emptyStarSvg))
      .join("");

    reviewsContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-4">Customer reviews</h4>
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex items-center mb-3">
          <div class="flex">${allStars}</div>
          <span class="ml-3 text-lg font-semibold">${rating}</span>
          <span class="ml-2 text-sm text-gray-600">(${reviews})</span>
        </div>
        <p class="text-sm text-gray-600 italic mb-2">
          "Fast service and professional assessment. The energy certificate was delivered exactly within the promised timeframe."
        </p>
        <p class="text-xs text-gray-500">- Verified customer</p>
      </div>
    `;
    reviewsContent.classList.remove("hidden");
    reviewsTab.classList.add("bg-gray-100", "font-medium");
  }
};
  /* =======================
     Utils
  ======================= */


  

function enrichWithCatastroResult(propertyData, catastroResult) {
  const bi =
    catastroResult?.consulta_dnprcResult?.bico?.bi ||
    catastroResult?.consulta_dnplocResult?.bico?.bi;

  if (!bi) return propertyData;

  const codigos = collectCodigoRegistrales(bi);

  return {
    ...propertyData,
    provincia: bi.dt?.np ?? propertyData.provincia,
    municipio: bi.dt?.nm ?? propertyData.municipio,
    codigoPostal:
      bi.dt?.locs?.lous?.lourb?.dp ?? propertyData.codigoPostal,

    // ✅ nieuw
    anoConstruccion: bi.debi?.ant ?? propertyData.anoConstruccion,

    superficie: bi.debi?.sfc ?? propertyData.superficie,
    codigoRegistrales: codigos,
  };
}

  function loadingHtml(text) {
    return `
      <div class="text-center py-6 text-sm text-gray-500">
        <span class="animate-spin inline-block w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full mr-2"></span>
        ${text}
      </div>
    `;
  }

  return { init };
}